import { attach, type Effect } from 'effector'

import { $i18n, type Translation } from '@/shared/lib/i18n'

export function attachI18n<Data>(
    effect: Effect<{ message: string }, Data>,
    code: keyof Translation
): Effect<any, Data> {
    return attach({
        source: $i18n,
        mapParams: (_params, { i18n }) => ({
            message: i18n[code],
        }),
        effect: effect,
    })
}
